import React from 'react';
import Scroll from 'react-scroll';

import FieldMultiValItem from './FieldMultiValItem';
import Const from '../../util/Constants';
import RegEx from '../../util/RegEx';

class FieldMultiValue extends React.Component {

  constructor(props) {
    super(props);
    this.visible = props.field.visible === Const.True;
    this.editable = props.field.editable === Const.True;
    this.LabelName = props.field.label_name;
    this.regex = props.field.validate;
    this.Key = props.id;
    this.type = props.field.field_type;
    
    let value = props.value;
    value = value !== undefined && value !== null && value !== '' && value !== '~~' ?
    value.substring(1, value.length - 1) : '';
    this.values = value !== '' ? value.split(Const.Opt) : [ '' ];
    this.state = { inValid: props.inValid, changed: false };
  }
  
  UNSAFE_componentWillReceiveProps(props) {
    if(JSON.stringify(this.state.inValid) !== JSON.stringify(props.inValid)) {
      this.setState({ ...this.state, inValid: props.inValid ? props.inValid : {} })
    }
  }

  delete = index => {
    this.values = this.values.filter((_, i) => i !== index);
    const value  = `${Const.Opt}${this.values.join(Const.Opt)}${Const.Opt}`;
    this.props.onValueChange(this.props.id, value);
    this.setState({ ...this.state, changed: !this.state.changed });
  }

  update = (index, val) => {
    this.values[index] = val;
    const value  = `${Const.Opt}${this.values.join(Const.Opt)}${Const.Opt}`;
    this.props.onValueChange(this.props.id, value);
  }

  add = () => {
    this.values.push('');
    const value  = `${Const.Opt}${this.values.join(Const.Opt)}${Const.Opt}`;
    this.props.onValueChange(this.props.id, value);
    this.setState({ ...this.state, changed: !this.state.changed });
  }

  render() {
    if(!this.visible || !this.editable) return null;

    let valueList = [];
    for(let i = 0; i < this.values.length; i++) {
      valueList.push(
        <FieldMultiValItem key={`mul_${this.props.id}_${i}`} index={i}
          value={this.values[i]} add={this.add} delete={this.delete}
          LabelName={this.LabelName}
          onChange={this.update} validate={this.regex} inValid={{}} />);
    }
    return (
      <div className="col contactinfodiv">
        <Scroll.Element name={this.Key} />
        <label>{this.LabelName} {RegEx.showError(this.state.inValid, this.Key)}</label>
        {valueList}
      </div>
    );
  }
}
export default FieldMultiValue;